import { TERMS_OF_SERVICE_DOCUMENT } from "@-/dev.improve.haniverse.lib.legal";
import { LegalDocumentBody } from "#legal-document-body";

/** The Terms of Service body. The public website renders the same text at `/terms`. */
export function TermsDocumentBody() {
  return <LegalDocumentBody document={TERMS_OF_SERVICE_DOCUMENT} />;
}
